import {
  ToggleButtonGroup as MUIToggleButtonGroup,
  ToggleButtonGroupProps
} from "@mui/material"
import { forwardRef } from "react"
import { useStyles } from "./styles"

interface Props extends ToggleButtonGroupProps {
  value: string
  size?: "small" | "medium" | "large"
  className?: string
}

const ToggleButtonGroup = forwardRef<HTMLDivElement, Props>(
  ({ value, size = "medium", className, children, ...props }, ref) => {
    const { classes, cx } = useStyles()

    return (
      <MUIToggleButtonGroup
        ref={ref}
        className={cx(classes.toggleButtonGroup, classes[size], className)}
        value={value}
        {...props}
      >
        {children}
      </MUIToggleButtonGroup>
    )
  }
)

export default ToggleButtonGroup
